<app-section-header
  [title]="props.label"
  [helpText]="props.helpText"
  [helpUrl]="props.helpUrl"
>
</app-section-header>
